import { useMemo } from "react";
import useGroupsContext from "hooks/useGroupsContext";
import type { Athlete } from "types/athlete";
import Grid from "components/primitives/Grid";
import Tooltip from "components/TooltipV2";
import GroupTooltipTitle from "./GroupTooltipTitle";
import { useTranslation } from "react-i18next";

function GroupColorBlocks(props: Athlete) {
  const [groups] = useGroupsContext();
  const { t } = useTranslation();

  const athleteGroups = useMemo(
    () => groups.filter((group) => props.groupIds.includes(group.id)),
    [groups, props.groupIds]
  );

  return (
    <Grid
      container
      height="100%"
      sx={{
        width: "100%",
      }}
    >
      {athleteGroups.map((group) => (
        <Tooltip
          key={group.id}
          disableInteractive
          title={<GroupTooltipTitle group={group} />}
          placement="top"
          size="small"
          slotProps={{ tooltip: { sx: { padding: "4px 8px" } } }}
        >
          <Grid
            role="img"
            aria-label={t("global.group_color_indicator", { group: group.name })}
            key={group.id}
            bgcolor={group.colour}
            maxWidth={8}
            flex={1}
          />
        </Tooltip>
      ))}
    </Grid>
  );
}

export default GroupColorBlocks;
